import {
  FETCH_INVOICES_REQUEST,
  FETCH_INVOICES_SUCCESS,
  FETCH_INVOICES_FAILURE,
} from "./invoiceActionTypes";

export const fetchInvoicesRequest = () => ({
  type: FETCH_INVOICES_REQUEST,
});

export const fetchInvoicesSuccess = (data) => ({
  type: FETCH_INVOICES_SUCCESS,
  payload: data,
});

export const fetchInvoicesFailure = (error) => ({
  type: FETCH_INVOICES_FAILURE,
  payload: error,
});
